var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('feather-icon',{class:this.params.data.data_status == 'verified' ? 'text-primary' : '',attrs:{"icon":"CheckIcon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.verifiedSocio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }